import React, {useCallback, useMemo, useRef, useState} from 'react';
import {Content, DrawerContent, MultiDestinationBtn, NameContent, NameWrapper, SearchBox, SearchIcon, SearchInput, SearchItem, SectionTitle} from "./styles";
import {StyledParagraph, StyledText, StyledTitle} from "../CustomAntdComponents/Typography";
import {useStore} from "../../store/global/appStore";
import {SuggestionType} from "./index";
import { FixedSizeList as List } from 'react-window';
import { ReactComponent as FlightIcon } from "../../assets/images/flight-takeoff.svg";
import { ReactComponent as FlightLandIcon } from "../../assets/images/flight-land.svg";
import { Global } from '@solar-icons/react';

const suggestedSearches: SuggestionType[] = [
    {
        name: "Lagos, Nigeria",
        label: "Murtala Muhammed International Airport",
        code: "LOS",
        value: "LOS"
    },
    {
        name: "Nairobi, Kenya",
        label: "Jomo Kenyatta International Airport",
        code: "NBO",
        value: "NBO",
    },
    {
        name: "Abuja, Nigeria",
        label: "Nnamdi Azikiwe International Airport",
        code: "ABV",
        value: "ABV"
    },
    {
        name: "Mombasa, Kenya",
        label: "Moi International Airport",
        code: "MBA",
        value: "MBA",
    },
    {
        name: "Kano, Nigeria",
        label: "Mallam Aminu Kano International Airport",
        code: "KAN",
        value: "KAN",
    },
    {
        name: "Eldoret, Kenya",
        label: "Eldoret International Airport",
        code: "EDL",
        value: "EDL",
    },
    {
        name: "London, England",
        label: "London Heathrow Airport",
        code: "LHR",
        value: "LHR"
    },
    {
        name: "Accra, Ghana",
        label: "Kotoka International Airport",
        code: "ACC",
        value: "ACC"
    },
    {
        name: "Mississauga, Ontario",
        label: "Toronto Pearson International Airport",
        code: "YYZ",
        value: "YYZ"
    }
];

const SelectSearches = ({
    onSelect,
    searchText,
    setSearchText,
    height = 500,
    limitSuggestionHeight,
    mode,
    disabled = false,
    allowMultipleDestinations = false,
    onAddMultipleDestinations,
    setIsOpen
}: {
        limitSuggestionHeight?: boolean,
        height?: number,
        onSelect: (airport: string) => void;
        searchText: string;
        setSearchText: (value: string) => void;
        mode: string;
        disabled?: boolean,
        allowMultipleDestinations?: boolean,
        onAddMultipleDestinations?: () => void;
        setIsOpen?: (isOpen: boolean) => void;
}) => {
      const searchRef = useRef<HTMLInputElement>(null);
    
    
    
    const isFrom = mode === "from";
  const popoverTitle = isFrom
    ? "Where are you departing from?"
    : "Where is your destination?";
    const { airports } = useStore();
    const airportsList = airports;

    const filteredOptions = useMemo(() => {
        const textLower = searchText.toLowerCase();
        return airportsList.filter((option) => {
            const concatenatedFields = `${option?.Code} ${option?.StateName} ${option?.StateCode} ${option?.Name}`.toLowerCase();
            return concatenatedFields.includes(textLower);
        });
    }, [airportsList, searchText]);

    const filteredLength = filteredOptions.length
    const suggestionHeight = limitSuggestionHeight ? `${height}px` : "100%";


    return (
        <Content height={suggestionHeight}>
            <SectionTitle>
                <StyledText size="16px">{popoverTitle}</StyledText>
            </SectionTitle>

            <SearchBox>
                <SearchIcon>
                {isFrom ? <FlightIcon /> : <FlightLandIcon />}
                </SearchIcon>

                <SearchInput
                ref={searchRef}
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                placeholder={isFrom ? "From:" : "To:"}
                aria-label={isFrom ? "Search departure airport" : "Search destination airport"}
                />
            </SearchBox>
            {searchText && filteredLength === 0 && (
                <SectionTitle>
                <StyledParagraph align="center" size="normal">
                    No results found.
                </StyledParagraph>
                </SectionTitle>
            )}

            {searchText ? (
                <List
                height={height}
                itemCount={filteredOptions.length}
                itemSize={66}
                width="100%"
                >
                {({ index, style }) => {
                    const option = filteredOptions[index];

                    return (
                    <div style={{ ...style, paddingLeft: "16px", paddingRight: "16px" }}>
                        <SearchItem onClick={() => onSelect(option.Code)}>
                        <NameWrapper>
                            <NameContent>
                            <StyledTitle level={5}>
                                {`${option.StateCode}, ${option.StateName}`}
                            </StyledTitle>
                            <StyledText>{option.Name}</StyledText>
                            </NameContent>
                        </NameWrapper>
                        <StyledTitle level={4}>{option.Code}</StyledTitle>
                        </SearchItem>
                    </div>
                    );
                }}
                </List>
            ) : (
                <>
                {!isFrom && allowMultipleDestinations && (
                    <MultiDestinationBtn
                    type="button"
                    onClick={() => {
                        onAddMultipleDestinations?.();
                        setIsOpen?.(false);
                    }}
                    >
                    <Global />
                    Add multiple destinations
                    </MultiDestinationBtn>
                )}

                {suggestedSearches.map((search, index) => (
                    <SearchItem key={index} onClick={() => onSelect(search.value)}>
                    <NameWrapper>
                        <NameContent>
                        <StyledTitle level={5}>{search.name}</StyledTitle>
                        <StyledText>{search.label}</StyledText>
                        </NameContent>
                    </NameWrapper>
                    {search?.code && <StyledTitle level={4}>{search.code}</StyledTitle>}
                    </SearchItem>
                ))}
                </>
            )}
        </Content>
    )
};



export default SelectSearches;
